import React, {Component, Fragment, useState} from 'react';

import {
    uploadLocalPagesCsv
} from "../manageLocations/localPages/LocalPagesApi";
import { ToastService } from '../../../components/toasts/Toasts';
import FileDrop from "../../../components/Forms/FileDrop";
import Button from "../../../components/buttons/Button";
import RegionCard from "../../../components/cards/RegionCard";
import RegionCardBody from  "../../../components/cards/RegionCardBody";
import RegionCardHeader from "../../../components/cards/RegionCardHeader";
import RegionCardFooter from "../../../components/cards/RegionCardFooter";

let csvAcceptType = ".csv"
class LocalPagesUploader extends Component {

    state = {
        // Initially, no file is selected
        selectedFile: null,
        fileUploading: false,
        buttonEnabled: false,
        errorMessage: null,
        successCountMessage: null
    };


    // On file select (from the pop up)
    onFileChange = files => {
        // Update the state
        this.setState({ selectedFile: files[0] });
        this.setState({ buttonEnabled: true });
        this.setState({successCountMessage: null})
        this.setState({errorMessage: null})

    };

    // On file upload (click the upload button)
    onFileUpload = () => {

        this.setState({fileUploading: true})

        // Create an object of formData
        const formData = new FormData();

        // Update the formData object
        formData.append(
            "myFile",
            this.state.selectedFile,
            this.state.selectedFile.name
        );

        // Request made to the backend api
        // Send formData object
        uploadLocalPagesCsv(formData)
            .then(resp => {
                this.setState({fileUploading: false})
                this.setState({successCountMessage: resp.localPageContentsAddedOrUploaded})
                this.setState({ buttonEnabled: false });
                ToastService.success("Upload complete", `Successfully Added/Updated: ${resp.localPageContentsAddedOrUploaded} Local Pages`);
            })
            .catch(e => {
                this.setState({fileUploading: false})
                this.setState({ errorMessage: "Error uploading: " + this.state.selectedFile.name + "\n" + e.response.data.errors.join("\n") })
                this.setState({ buttonEnabled: false });
                this.setState({selectedFile: null})
            })
    };

    // File content to be displayed after
    // file upload is complete
    fileData = () => {

        if (this.state.selectedFile) {

            return (
                <div>
                    <h4>File Details:</h4>
                    <p>File Name: {this.state.selectedFile.name}</p>
                </div>
            );
        } else {
            return <Fragment />
        }
    };

    render() {
        return (
            <RegionCard>
                <RegionCardHeader title="File Uploader"/>
                <RegionCardBody>
                    <div className="d-flex align-items-start flex-column">
                        <FileDrop containerClassName="d-flex h-100 w-100"
                                  maxSize={100000} // TODO: How much?
                                  onFileAdded={files => {
                                      this.onFileChange(files);
                                  }}
                                  accept={csvAcceptType}
                        >

                            <div className="d-flex flex-column align-items-center justify-content-center border card-padding flex-1">
                                <p>
                                    <i className="far fa-cloud-upload fa-5x"></i>
                                </p>
                                {!this.state.selectedFile ? <><p>
                                    Drag and drop a .CSV file.
                                </p>
                                <p>
                                    or
                                </p></>
                                    :
                                    <p>{this.state.selectedFile.name}</p>
                                }
                                <Button className="px-5">Choose  File</Button>
                            </div>                            </FileDrop>
                        <button disabled={!this.state.buttonEnabled} className="btn btn-secondary content-spacer-top ml-auto" onClick={this.onFileUpload}>
                            Upload
                        </button>
                    </div>
                </RegionCardBody>
                <RegionCardFooter>
                    {!!this.state.errorMessage && <div className="alert alert-danger"><i className="fas fa-exclamation-circle fa-status"></i>{
                        this.state.errorMessage.split ('\n').map ((item, i) => <p key={i}>{item}</p>)
                    }</div>}
                    </RegionCardFooter>
            </RegionCard>

        );
    }
}

export default LocalPagesUploader;